import { render, staticRenderFns, recyclableRender, components } from "./select.vue?vue&type=template&id=215d2dd9&scoped=true&"
var renderjs
import script from "./select.vue?vue&type=script&lang=js&"
export * from "./select.vue?vue&type=script&lang=js&"
import style0 from "./select.vue?vue&type=style&index=0&id=215d2dd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215d2dd9",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "shop/pages/select/select.vue"
export default component.exports